module.exports = __webpack_public_path__ + "img/icon-pencil.ef2ff948.svg";